module.exports = __webpack_public_path__ + "cross-b34958b9651a35b7f888a0c6f913c77a.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/icons/cross.svg
// module id = 52
// module chunks = 0